<nav @menu *ngIf="displayMenu" class="d-flex pb-4">
  <button (click)="toggleMenu(false)" class="py-3 px-4 mr-2 position-absolute">&#x2715;</button>
  <ul class="my-auto pb-5">
    <li>
      <a [routerLink]="" fragment="iOSInstructions" (click)="toggleMenu(false);">
        <!-- <ng-template [ngIf]="language == 'en'">Troubleshooting</ng-template>
        <ng-template [ngIf]="language == 'es'">Solución de problemas</ng-template> -->
        Troubleshooting
      </a>
    </li>
    <li class="mt-2">
      <a href="http://www.sonomaplazahistory.com/donate/">
        <!-- <ng-template [ngIf]="language == 'en'">Donate</ng-template>
        <ng-template [ngIf]="language == 'es'">Donar</ng-template> -->
        Donate
      </a>
    </li>
    <li class="mt-5 pt-2">
      <a href="http://www.sonomaplazahistory.com/">
        <b>
          <!-- <ng-template [ngIf]="language == 'en'">Exit Tour</ng-template>
          <ng-template [ngIf]="language == 'es'">Tour de salida</ng-template> -->
          Exit Tour
        </b>
      </a>
    </li>
  </ul>
</nav>

<div class="container-fluid position-absolute nav-top pt-4">
  <div class="row">
    <div class="col-3">
      <button tabindex="1" (click)="toggleMenu(true)" class="py-0 px-0" aria-label="Open navigation menu"><img
          src="../../assets/menu.svg" alt="Navigation menu icon"></button>
    </div>
    <div class="col-auto ml-auto my-auto">
      <a tabindex="2" href="http://sonomaplazahistory.com" target="_blank" rel="noopener noreferrer"
        aria-label="Sonoma Plaza History website link"><img class="logo" src="../../assets/logo.png"
          alt="Sonom Plaza History logo"></a>
    </div>
  </div>
</div>
